import { createActionType } from 'helpers'

export const ADD = createActionType('FEEDBACK', 'ADD')
export const CLEAR = createActionType('FEEDBACK', 'CLEAR')
